import { makeAutoObservable } from 'mobx'

class UserAttendanceUIStore {
   private _isClockInModalOpen!: boolean

   private constructor() {
      makeAutoObservable(this, {}, { autoBind: true })
   }

   get isClockInModalOpen(): boolean {
      return this._isClockInModalOpen
   }

   setIsClockInModalOpen(): void {
      this._isClockInModalOpen = true
   }

   closeClockInModal(): void {
      this._isClockInModalOpen = false
   }

   static createStore(): UserAttendanceUIStore {
      return new UserAttendanceUIStore()
   }
}

export default UserAttendanceUIStore
